import React, { useEffect } from 'react';
import cl from './Home.module.css';
import Product from '../Products/Product/Product';
import { animateScroll as scroll } from 'react-scroll';
import hero from '../../image/hero.png';
import bag from '../../image/handmade-paper-bags.webp';

export const getRandomNumber = (min, max) => {
  return Math.round(min + Math.random() * (max - min));
};

const Home = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < 6) {
      return (
        <Product
          key={getRandomNumber(1, 10000)}
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={'products/' + p.path}
          cartItems={props.cartItems}
        />
      );
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section>
      <div
        style={{ paddingTop: '100px', textAlign: 'center' }}
        className={cl.app_about}
      >
        <h1 className={cl.title}>
          Compra con placer <br /> en <br />
          {props.aboutData.shopName}!
        </h1>
        <div className={cl.hero} style={{ width: '50vw' }}>
          <img src={bag} alt="bags" />
        </div>
        <div
          style={{
            width: '100%',
            height: '50px',
            backgroundColor: 'var(--primary)',
          }}
        ></div>
        <div className={cl.about_products}>{productElements}</div>
        <div
          style={{
            width: '100%',
            height: '25px',
            backgroundColor: 'var(--primary)',
          }}
        ></div>
        <div className={cl.hero}>
          <img src={hero} alt="hero" />
        </div>
      </div>
    </section>
  );
};

export default Home;
